/**
 * Created by Mark on 17/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    ALL: ENVIRONMENT_CONSTANTS.BASE_URL + '/SongsAndStories/getAll',
    ALL_UPDATE: 'SONGS_ALL_UPDATE',
}


// WEBPACK FOOTER //
// ./src/constants/songs-and-stories.js